"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MapPinElement: ()=>MapPinElement
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_SinglePinIcon_js_namespaceObject = require("./SinglePinIcon.js");
const external_SinglePinLabel_js_namespaceObject = require("./SinglePinLabel.js");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_getMapPinOnClickHandler_js_namespaceObject = require("./getMapPinOnClickHandler.js");
const StyledFlex = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "MapPinElement__StyledFlex"
})([
    ":hover{cursor:pointer;}"
]);
const MapPinElement = (props)=>{
    const domRef = external_react_default().useRef(null);
    domRef.current = props.markerDOM;
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (domRef.current) domRef.current.addListener('click', (event)=>{
            const handler = (0, external_getMapPinOnClickHandler_js_namespaceObject.getMapPinOnClickHandler)(props);
            handler(event);
        });
    }, []);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ThemeProvider, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(StyledFlex, {
            alignItems: "center",
            style: {
                transform: 'translateX(50%)'
            },
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_SinglePinIcon_js_namespaceObject.SinglePinIcon, {
                    ...props
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_SinglePinLabel_js_namespaceObject.SinglePinLabel, {
                    ...props
                })
            ]
        })
    });
};
exports.MapPinElement = __webpack_exports__.MapPinElement;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MapPinElement"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
